const configs = [
	{
		host: 'easyplus.de',
		apiUrl: '//api.thunderchild.es/',
		apiKey: 'easyplus-de',
		locale: 'de-DE',
		currency: 'EUR',
		title: 'EasyPlus',
		googleAnalyticsId: 'UA-106419190-1',
		favicon: 'https://cdn.thunderchild.es/easyplus-de/favicon.ico'
	}
]

const config = configs.find(config => config.host === window.location.hostname)

export default config || {
	host: 'localhost',
	apiUrl: 'https://api.thunderchild.es/',
	apiKey: 'easyplus-de',
	locale: 'fr-FR',
	currency: 'EUR',
	title: 'EasyPlus',
	// googleAnalyticsId: 'UA-109318970-1',
	favicon: 'https://cdn.thunderchild.es/easyplus-de/favicon.ico'
}



// WEBPACK FOOTER //
// ./src/utils/config.js